import type { CtaItemDto, NavItemDto } from '@/lib/sanity/dto';
import { UiButtonLabel } from '@/components/ui/UiButtonLabel';
import { UiIcon } from '@/components/ui/UiIcon';
import { stegaClean } from '@/lib/utils/stega';

type LinkLabelProps = {
    item: NavItemDto | CtaItemDto;
};

/**
 * Default content of a link: the label, plus the optional icon the editor
 * picked. Position falls back to `right`, matching the schema's initial value.
 * The `.btn` classes already space the two via `--btn-gap`; in a button the
 * label ends in an ellipsis rather than overflowing (UiButtonLabel).
 */
export function LinkLabel({ item }: LinkLabelProps) {
    const icon = stegaClean(item.icon);
    const label = <UiButtonLabel>{item.label}</UiButtonLabel>;
    if (!icon) return label;

    // em-based, so the icon scales with the button size (btn 14px → 17.5, btn-lg 16px → 20).
    const iconNode = <UiIcon name={icon} size="1.25em" className="shrink-0" aria-hidden="true" />;
    const isLeading = stegaClean(item.iconPosition) === 'left';

    return (
        <>
            {isLeading ? iconNode : null}
            {label}
            {isLeading ? null : iconNode}
        </>
    );
}
